import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { featchInvoices } from '../../context/CommonContex';
import messages from '../../statics/messages.json';

const Invoices = () => {
    const navigate = useNavigate();
    const [invoiceData, setInvoiceData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const fetchInvoicesData = async (index, maxRecords) => {
        try {
            const response = await featchInvoices(index, maxRecords, searchTerm);
            if (response) {
                setInvoiceData(response.content || response.invoice || []);
                setTotalRecords(response.totalElements || response.totalRecords || 0);
            }
        } catch (error) {
            console.error('Error fetching invoices:', error);
            if (error.response?.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        fetchInvoicesData(currentPage - 1, itemsPerPage);
    }, [currentPage, itemsPerPage, searchTerm]);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount || 0);
    };

    const getStatusColor = (status) => {
        const statusMap = {
            'Overdue': 'bg-danger text-white',
            'Pending': 'bg-warning text-dark',
            'Paid': 'bg-success text-white',
            'Partially Paid': 'bg-info text-white',
            'Draft': 'bg-secondary text-white'
        };
        return statusMap[status] || 'bg-light text-dark';
    };

    return (
        <div className="box-body border b-white rounded-2">
            <h4 className="p-2 m-0 border-bottom">Invoices</h4>

            <div className='row p-2'>
                <div className="col-1">
                    <select
                        className="form-select"
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value={totalRecords}>All</option>
                    </select>
                </div>
                <div className="col-8"></div>
                <div className="col-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={messages.search_label}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                </div>
            </div>

            <div className="row px-2 over-flow-table">
                <div className="col-12 px-2">
                    <table className="table gf-table border rounded">
                        <thead className="table-sticky-head">
                            <tr>
                                <th>Invoice #</th>
                                <th>Customer</th>
                                <th>Cust PO NO #</th>
                                <th>Date</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceData.length > 0 ? (
                                invoiceData.map((invoice) => (
                                    <tr key={invoice.id}>
                                        <td>{invoice.invoiceNum || invoice.invoicenum}</td>
                                        <td>{invoice.customer?.name || 'N/A'}</td>
                                        <td>{invoice.custpoNum || invoice.custponum || 'N/A'}</td>
                                        <td>{invoice.invoiceDate || invoice.invoicedate}</td>
                                        <td>{invoice.ar_dueDate || invoice.ar_duedate}</td>
                                        <td>{invoice.total_invoice_amount}</td>
                                        <td>
                                            <span className={`badge ${getStatusColor(invoice.ar_status)}`}>
                                                {invoice.ar_status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">No invoices found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="col-12 py-2">
                    <nav aria-label="Page navigation" className="d-flex justify-content-between align-items-center">
                        <span>
                            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, totalRecords)} to{' '}
                            {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords}
                        </span>

                        <ul className="pagination mb-0 align-items-center">
                            {/* Previous Button */}
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                                    Previous
                                </button>
                            </li>

                            {/* Page Select Dropdown */}
                            <li className="page-item">
                                <select
                                    className="form-select mx-2"
                                    style={{ width: 'auto' }}
                                    value={currentPage}
                                    onChange={(e) => handlePageChange(Number(e.target.value))}
                                >
                                    {[...Array(totalPages)].map((_, index) => (
                                        <option key={index} value={index + 1}>
                                            Page {index + 1}
                                        </option>
                                    ))}
                                </select>
                            </li>

                            {/* Next Button */}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Invoices;
